











































































































































































































declare var window: any;
import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { UserProfile } from '../../../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import { ResumeWrapper } from '../../../models/jobs/resumeWrapper';
import { Resume } from '../../../models/jobs/resume';
import { ResumeRecord } from '../../../models/jobs/resumerecord';
import { ResumePayload } from '../../../models/jobs/resumepayload';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import UploadResumeSection from '@/components/Commons/UploadResumeSection.vue';

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'SurveyFileUpload',
  components: {
    Datepicker,
    UploadResumeSection,
  },
})
export default class SurveyFileUpload extends Mixins(GuidedSignupUtilities) {
  $wlToastr: any;
  @Prop() fileSize;
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  private resumePayload: ResumePayload = new ResumePayload();
  private currentResumeName: string = '';
  private currentResume: ResumeRecord = new ResumeRecord();
  private selectedResume: ResumeRecord = new ResumeRecord();
  private errorString: string = '';
  //new variables
  private showUploadText: boolean = true;
  private selectedNewResume: ResumeRecord = new ResumeRecord();
  private supportedFileSize = 0;
  private anonResumeUploaded: boolean = false;
  private isDefaultResume :boolean = false;

  @Prop({ default: () => new Vue(), type: Vue }) bus;

  @Watch('resumeListing')
  resumeListingUpdated(newList, oldList) {
    this.$emit('disable-next-button', newList.resumes.length === 0);
  }

  get SelectedResume(): ResumeRecord {
    return this.selectedResume;
  }

  get thisURL() {
    return window.location.href.split('/')[
      window.location.href.split('/').length - 1
    ];
  }

  get isAnonResumeUploaded():boolean{
return (this.anonResumeUploaded && !this.isDefaultResume);
  }

  get ResumeListing(): ResumeWrapper {
    return this.resumeListing;
  }

  selectResume(resume: ResumeRecord) {
    this.selectedResume = resume;
  }

  async downloadResume(resume) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + resume.fileGUID;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`, 
        },
      });
      
      if (!response.ok) {
        throw new Error('Failed to download resume');
      }
      
      const blob = await response.blob();
      
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = resume.name;
      
      // Trigger a click event to initiate the download
      link.click();
      
      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }


  async selectFromDropbox() {
    const vm = this;
    vxm.users
      .uploadDropboxResume()
      .then(async (status) => {
        console.log('STATUS:', status);
        if (status === 'success') {
          vm.$wlToastr('success', vm.$t('SkillsDetails_SuccessfullyUploaded'), vm.$t('ResumeDetails_UploadResume'));
          const listPromise = await vxm.jobs.getResumeListing(
            vxm.users.getToken,
          );
          vm.resumeListing = vxm.jobs.resumeListing;
        } else {
          vm.$wlToastr('info', vm.$t('SkillsDetails_CancelUpload'), vm.$t('ResumeDetails_UploadResume'));
        }
      })
      .catch((err) => {
        vm.$wlToastr('error', vm.$t('ResumeDetails_UploadResumeError'), vm.$t('ResumeDetails_UploadResume'));
      });
  }

  get allowedFormats() {
    const array = vxm.configs
      .getGlobalConfigValue('ALLOWED_RESUME_FORMATS')
      .split(',');
    return vxm.utility.commaAndSeparator(array);
  }

  get isDropboxEnabled() {
    if (
      vxm.configs.getGlobalConfigBooelanValue('WL_DROPBOX_INTEGRATION_ENABLED')
    ) {
      if (vxm.configs.getGlobalConfigValue('DROPBOX_APP_KEY')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async deleteResume(resume: ResumeRecord) {
    const vm = this;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    var userId   = params.get('userid');
    var userIdnum;


        if(userId != null ){
          userIdnum = parseInt(userId);
        }
        else{
          userIdnum = -1;
        }
    if (resume && resume.defaultResume !== true) {
      if (!resume.fileGUID) {
        this.$wlToastr('error', this.$t('profile.resume.select.required'), '');
      } else {
        if(!this.isUserLoggedIn){
          resume.userId = userIdnum;
        }
        const respPromise = vxm.users.deleteResume(resume);
        if(this.isUserLoggedIn){
        const listPromise = vxm.jobs.getResumeListing(vxm.users.getToken);
        const [resp, list] = await Promise.all([respPromise, listPromise]);

        if (resp.success) {
          this.$wlToastr('success', resp.successMessage, this.$t('ResumeDetails_DeleteResume'));
          const token = vxm.users.getToken;
          vxm.jobs.getResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
          if(this.resumeListing.resumes.length == 0){
            this.$emit('remove-resume')
          }

        } else {
          this.$wlToastr('error', resp.errorMessage, this.$t('ResumeDetails_DeleteResume'));
        }
      }
      else{
      const [resp] = await Promise.all([respPromise]);
      if (resp.success) {
        this.anonResumeUploaded = false;
        this.$wlToastr('success', resp.successMessage, this.$t('ResumeDetails_DeleteResume'));
        this.ResumeListing.resumes=[]
        this.$emit('remove-resume')
      }
      else{
        this.$wlToastr('error', resp.errorMessage, this.$t('ResumeDetails_DeleteResume'));

      }

    }
    }
   
    } else {
      this.$wlToastr(
        'error',
        this.errorString,
       this.$t('ResumeDetails_DefaultResumeDeleteError'),
      );
    }
  }

  renameResume(resume: ResumeRecord) {
    if (resume) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('resume.label.renameresume'),
        );
      } else {
        this.currentResume = resume;
        this.currentResumeName = resume.name;
        this.$modal.show('rename-resume');
      }
    }
  }
  cancelRename() {
    this.$modal.hide('rename-resume');
  }

  get isUserLoggedIn(){
    return vxm.users.isLoggedIn;
  }
  async defaultResume(resume: ResumeRecord) {
    const vm = this;
    if (resume) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('ResumeDetails_SetDefaultResume'),
        );
      } else {
        const respPromise = vxm.users.defaultResume(resume);
        const listPromise = vxm.jobs.getResumeListing(vxm.users.getToken);
        const [resp, list] = await Promise.all([respPromise, listPromise]);

        console.log(['in default resume', resp, list]);
        if (resp.success) {
          this.$wlToastr('success', resp.successMessage, this.$t('ResumeDetails_SetDefaultResume'));

          const token = vxm.users.getToken;
          vxm.jobs.getResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
        } else {
          this.$wlToastr('error', resp.errorMessage, this.$t('ResumeDetails_SetDefaultResume'));
        }
      }
    }
  }

  async uploadResume() {
    const vm = this;

    const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);

var userId   = params.get('userid');
var userIdnum;


if(userId != null ){
  userIdnum = parseInt(userId);
}
else{
  userIdnum = -1;
}
    const token = vxm.users.getToken;
    this.resumePayload.accessToken = token;
    this.resumePayload.jobpostingid = -1;
    this.resumePayload.resumelink = '';
    this.resumePayload.userId = userIdnum;

    if (this.validateFileSize(this.resumePayload.resumefile)) {
      if (this.validateUploadResume(this.resumePayload)) {
        const respPromise = vxm.jobs.postProfileResume(this.resumePayload);
        const [resp] = await Promise.all([respPromise]);
        if (resp.success) {
          this.$wlToastr(
            'success',
            this.$t('profile.upload.resume.sucess'),
            this.$t('ResumeDetails_UploadResume'),
          );
        this.$emit('resume-uploaded');
        if(!this.isUserLoggedIn){
        this.anonResumeUploaded = true;
        if(this.isDefaultResume){
          this.$wlToastr(
            'info',
            'Your last uploaded resume will be used. Please login to manage your previous resumes.',
           
          );
        }
      }
          // tslint:disable-next-line:no-shadowed-variable
          const token = vxm.users.getToken;
          if (vxm.users.isLoggedIn) {
            vxm.jobs.getApplyFlowResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
          }
          else{
            vxm.jobs.getAnonResumeListing(userIdnum).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
            this.isDefaultResume =this.resumeListing.resumes[0].defaultResume
          });
          }
       
          vxm.users.getProfileStrength();
        } else {
          this.$wlToastr(
            'error',
            this.$t('profile.upload.resume.error'),
            this.$t('ResumeDetails_UploadResume'),
          );
        }
      } else {
        this.$wlToastr('error', this.$t(this.errorString), this.$t('ResumeDetails_UploadResume'));
      }
    }
    this.resumePayload.resumefile = '';
  }
  validateFileSize(file) {
    console.log('validating file size for file : ', file);
    this.supportedFileSize =
      this.fileSize && this.fileSize != null
        ? this.fileSize * (1024 * 1024)
        : 10485760;
    console.log('Check again :' + this.supportedFileSize / (1024 * 1024));
    if (file.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', { maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return false;
    }
    return true;
  }

  validateUploadResume(resumePayload: ResumePayload): boolean {
    if (!resumePayload.resume.resumename) {
      this.errorString = 'profile.upload.resume.file.required';
      return false;
    }
    if (resumePayload.resume.resumename.length > 250) {
      this.errorString = 'profile.resume.file.name.exceeded';
      return false;
    }

    return true;
  }
  validateFileFormate() {
    const vm = this;
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }

  validationFileFormatResume() {
    const vm = this;
    console.log([vm.resumePayload]);
    this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
    // if (this.resumePayload.resume.resumename.length > 250) {
    //   this.$wlToastr(
    //     'error',
    //     'You have exceeded the maximum character limit of 250 characters for file name',
    //     'Upload Resume',
    //   );
    //   return;
    // }

    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    // if (!allowedResumeFormat.includes(ext)) {
    //   this.$wlToastr(
    //     'error',
    //     fileNameFormat +
    //       ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`,
    //     'Upload Resume',
    //   );
    //   vm.resumePayload.resumefile = '';
    // }
  }

  mounted() {
    this.bus.$on('on-next-step', () => {
      this.$emit('go-to-next');
    });
    if (vxm.users.isLoggedIn) {
      const token = vxm.users.getToken;
      vxm.jobs.getResumeListing(token).then(() => {
        this.resumeListing = vxm.jobs.resumeListing;
      });
  }
    else{
      var emptyResumeList: ResumeWrapper = new ResumeWrapper();

      emptyResumeList.sessionValid= null,
      emptyResumeList.errorCode= null,
      emptyResumeList.errorMessage=null,
      emptyResumeList.errorMessageData= null,
      emptyResumeList.verificationResult= null,
      emptyResumeList.appExpiry= null,
      emptyResumeList.profileStrengthInfo= null,
      emptyResumeList.resumes=[]
       this.resumeListing = emptyResumeList

    }
    this.supportedFileSize = vxm.utility.fileUploadMaxSize
  }

  //new mthods
  // toggleShowUploadText() {
  //   this.showUploadText = !this.showUploadText;
  // }
  async submitRename() {
    const vm = this;
    this.$modal.hide('rename-resume');
    this.currentResume.name = this.currentResumeName;
    const respPromise: any = vxm.users.renameResume(this.currentResume);
    const listPromise = vxm.jobs.getResumeListing(vxm.users.getToken);
    const [resp, list] = await Promise.all([respPromise, listPromise]);

    if (resp.success) {
      this.$wlToastr('success', resp.successMessage, this.$t('resume.label.renameresume'));
      const token = vxm.users.getToken;
      vxm.jobs.getResumeListing(token).then(() => {
        this.resumeListing = vxm.jobs.resumeListing;
      });
    } else {
      this.$wlToastr('error', resp.errorMessage, this.$t('resume.label.renameresume'));
    }
  }
}
